@use "../../styles/breakpoints";
@use "../../styles/text";

hp6-table {
  position: relative;
  display: block;
  table-layout: fixed;

  // mobile-first
  .hp-table-top-container {
    .hp-table-top {
      .hp-table-description {
        @include text.text-heading-xs;
      }

      .hp-table-text-select-container {
        display: block;
      }

      .hp-table-reset-button-container {
        display: none;
      }
    }
  }

  @include breakpoints.small-up {
    .hp-table-top-container {
      .hp-table-top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: var(--text-heading-line-height-xs);
        margin-bottom: var(--spacing-xs);

        // overridden from mobile-first above
        .hp-table-text-select-container {
          display: none;
        }

        // overridden from mobile-first above
        .hp-table-reset-button-container {
          &.visible {
            display: flex;
            align-items: center;

            hp6-button-decorator button {
              padding-right: 0;
            }
          }
        }
      }
    }
  }
}
